{
  "name": "web",
  "version": "0.0.21",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --ssl true --ssl-key ./ssl-key.pem --ssl-cert ./ssl-cert.pem --proxy-config proxy.conf.local.js -c local",
    "start:local": "ng serve --host 0.0.0.0 --port 4200 --ssl true --ssl-key ./ssl-key.pem --ssl-cert ./ssl-cert.pem --proxy-config proxy.conf.local.js -c local",
    "start-d3v": "ng serve --ssl true --ssl-key ./ssl-key.pem --ssl-cert ./ssl-cert.pem --proxy-config proxy.conf.d3v.js -c local",
    "start-local-localnet": "node start-local-localnet.js",
    "start-d3v-localnet": "node start-d3v-localnet.js",
    "build": "NODE_OPTIONS=--max-old-space-size=6144 ng build",
    "build:production": "NODE_OPTIONS=--max-old-space-size=6144 ng build -c production --output-hashing=all",
    "build:MOBI-PROD": "NODE_OPTIONS=--max-old-space-size=6144 ng build -c MOBI-PROD --output-hashing=all",
    "build:dev": "NODE_OPTIONS=--max-old-space-size=6144 ng build -c dev --output-hashing=all",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/core": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/router": "21.2.17",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/animations": "21.2.17",
    "@angular/cdk": "21.2.14",
    "@angular/material": "21.2.14",
    "@angular/material-moment-adapter": "21.2.14",
    "@ant-design/icons-angular": "21.0.0",
    "@fullcalendar/angular": "6.1.20",
    "@fullcalendar/core": "6.1.20",
    "@fullcalendar/daygrid": "6.1.20",
    "@fullcalendar/interaction": "6.1.20",
    "@fullcalendar/list": "6.1.20",
    "@fullcalendar/timegrid": "6.1.20",
    "@ng-idle/core": "16.0.0",
    "@ng-idle/keepalive": "16.0.0",
    "@ng-select/ng-select": "21.8.0",
    "@ngrx/effects": "21.1.0",
    "@ngrx/router-store": "21.1.0",
    "@ngrx/store": "21.1.0",
    "@ngrx/store-devtools": "21.1.0",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@openreplay/tracker": "18.0.4",
    "angular-shepherd": "22.0.0",
    "lodash-es": "4.18.1",
    "moment": "2.30.1",
    "moment-timezone": "0.6.1",
    "ng-zorro-antd": "21.2.2",
    "ngx-device-detector": "11.0.0",
    "ngx-mask": "21.0.1",
    "ngx-multiple-dates": "21.0.0",
    "ngx-socket-io": "4.10.0",
    "rxjs": "7.8.2",
    "seamless-scroll-polyfill": "2.3.4",
    "tslib": "2.8.1",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular/build": "21.2.17",
    "@angular/cli": "21.2.17",
    "@angular/compiler-cli": "21.2.17",
    "@angular-eslint/builder": "21.3.1",
    "@angular-eslint/eslint-plugin": "21.3.1",
    "@angular-eslint/eslint-plugin-template": "21.3.1",
    "@angular-eslint/schematics": "21.3.1",
    "@angular-eslint/template-parser": "21.3.1",
    "@types/lodash-es": "4.17.12",
    "@types/node": "22.19.17",
    "@typescript-eslint/eslint-plugin": "8.59.0",
    "@typescript-eslint/parser": "8.59.0",
    "eslint": "8.57.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.5",
    "prettier": "3.8.3",
    "ts-node": "10.9.2",
    "typescript": "5.9.3"
  },
  "overrides": {
    "@typescript-eslint/typescript-estree": {
      "minimatch": "9.0.7"
    }
  }
}
